import {FormModelText} from "./form.model.text";

/**
 * Textfield with a live street-address autocomplete dropdown.
 * @inheritDoc
 */
export class FormModelAddressAutocomplete extends FormModelText {

  /**
   * @inheritDoc
   */
  public type = 'address-autocomplete';
}
